import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';


const StatusField = ({ source = 'status', size = 'small', ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	const statuses = {
		'pending': translate('Pending'),
		'accepted': translate('Accepted'),
		'refused': translate('Refused')
	};


	if (!record) {
		return null;
	}
	const status = record[source];
	let sx = {};
	switch (status) {
		case 'accepted':
			sx = getChipColors('green');
			break;
		case 'refused':
			sx = getChipColors('red');
			break;
		default:
			break;
	}

	if (!status) {
		return null;
	}

	return (
		<ChipField source={status} record={statuses} sx={sx} size={size} {...props} />
	);
};

export default StatusField;
